import { render, staticRenderFns } from "./messageNotificationModal.vue?vue&type=template&id=97be34ec&scoped=true"
import script from "./messageNotificationModal.vue?vue&type=script&lang=js"
export * from "./messageNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./messageNotificationModal.vue?vue&type=style&index=0&id=97be34ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be34ec",
  null
  
)

export default component.exports